import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_57: FaireProductEntity = {
  token: "catalog_prod_prod-57",
  type: "product",
  name: "River Stone Mortar And Pedestal - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 16.92,
  msrpDollars: 42.3,
  sku: "JA0057",
  caseSize: 12,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 19,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
